import { services } from "@/service";
import { projectInfoConfig } from '@/constant';

const enterpriseInfo = sessionStorage.getItem('contract_enterprise_info');

export default {
  state: {
    enterpriseInfo: enterpriseInfo ? JSON.parse(enterpriseInfo) : null,
    vipArr: [],
    forecastSurplus: 0
  },
  getters: {
    isEnterprise: state => !!state.enterpriseInfo,
    isThird: state => {
      /**
       * projectInfoConfig.isDefault 为false时证明是第三方
       * 第三方的收费通过对接api生成包含企业id的token，当后端从header读不到企业id时会尝试去token内取
       */
      if (!projectInfoConfig.isDefault || !!(state.enterpriseInfo && state.enterpriseInfo.third)) {
        return true;
      }

      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const thirdPrefix = 'third_';
      if ((userInfo.id || '').slice(0, thirdPrefix.length) === thirdPrefix) {
        /**
         * 能够进来此处代表token已登录
         * 如果token未登录的情况正常会被重定向回到官网首页，重新登录后会重新加载当前spa项目的main.js和这里
         */
        return true;
      }

      return false;
    },
    caseInfo: state => {
      return state.vipArr.find(o => o.resourceCode === 'CASE');
    },
    caseIsExpired: (state, getters) => {
      if (!getters.caseInfo || !getters.caseInfo.dueTime) {
        return false;;
      }
      return Date.now() > (getters.caseInfo.dueTime);
    },
    caseFreeSurplus: (state, getters) => {
      if (!getters.caseInfo) {
        return 0;
      }
      const num = getters.caseInfo.unlimitedNumber - getters.caseInfo.resourceUsedDTO.extUsed;
      return num < 0 ? 0 : num;
    },
    lawInfo: state => {
      return state.vipArr.find(o => o.resourceCode === 'LAW');
    },
    lawIsExpired: (state, getters) => {
      if (!getters.lawInfo || !getters.lawInfo.dueTime) {
        return false;;
      }
      return Date.now() > (getters.lawInfo.dueTime);
    },
    lawFreeSurplus: (state, getters) => {
      if (!getters.lawInfo) {
        return 0;
      }
      const num = getters.lawInfo.unlimitedNumber - getters.lawInfo.resourceUsedDTO.extUsed;
      return num < 0 ? 0 : num;
    },
    forecastSurplus: state => state.forecastSurplus
  },
  actions: {
    async initVip({ commit, getters }) {
      if (getters.isEnterprise) {
        commit('setVipArr', []);
      } else {
        const result = await services.vip.getVipInfo();
        commit('setVipArr', result);
      }
    },
    async refreshForecastVip({ state }) {
      const item = await services.vip.getForecastVip();
      state.forecastSurplus = (item && item.degree) || 0;
    }
  },
  mutations: {
    setVipArr(state, vipArr) {
      state.vipArr = vipArr;
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/vip.js